import { useRef } from "react";
import { useOkapiKy, useStripes } from "@folio/stripes/core";
/**
 * Referentially stable variant of stripes-core `useOkapiKy`.
 *
 * `useOkapiKy` calls `ky.create(...)` on every render, so an effect, memo or
 * callback that lists the instance in its dependencies reruns on every render —
 * and an effect that then sets state turns into an endless render + request
 * loop. This hook keeps returning the same instance for as long as the okapi
 * settings the instance is built from (url, tenant, token, locale, timeout)
 * stay the same, and switches to a fresh one as soon as any of them changes.
 *
 * Use it wherever a ky instance feeds an effect / memo / callback dependency.
 */
export var useStableOkapiKy = function (options) {
    var _a, _b;
    var freshInstance = useOkapiKy(options);
    var okapi = ((_a = useStripes().okapi) !== null && _a !== void 0 ? _a : {});
    var key = JSON.stringify([
        okapi.url,
        (_b = options === null || options === void 0 ? void 0 : options.tenant) !== null && _b !== void 0 ? _b : okapi.tenant,
        okapi.token,
        okapi.locale,
        okapi.timeout,
    ]);
    var cacheRef = useRef(null);
    if (cacheRef.current === null || cacheRef.current.key !== key) {
        cacheRef.current = { key: key, instance: freshInstance };
    }
    return cacheRef.current.instance;
};
